export default __webpack_public_path__ + "static/media/star.3c83f285.svg";